module.exports = __webpack_public_path__ + "img/58_19.8c9e180f.png";